import React from "react";
import { CheckCircle2 } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

export function About() {
  const { t } = useLanguage();
  return (
    <section id="about" data-testid="about-section" className="relative py-24 md:py-32 bg-brand-cream">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <div className="relative max-w-md">
            <div className="relative arch-top rounded-b-2xl overflow-hidden border border-brand-sand shadow-xl shadow-brand-aegean/10">
              <img
                src="https://customer-assets-7cd3h4nn.emergentagent.net/job_handwerk-torrevieja/artifacts/1w6y32ag_WhatsApp%20Image%202026-07-07%20at%2012.49.05.webp"
                alt="Christian Reuter"
                className="w-full h-[440px] md:h-[520px] object-cover object-center"
              />
            </div>
            <div className="absolute -bottom-6 -right-4 bg-brand-terracotta text-white rounded-2xl px-5 py-4 shadow-lg">
              <div className="font-display text-2xl font-bold leading-tight">Meister</div>
              <div className="text-xs uppercase tracking-widest mt-1 opacity-90">
                Heizung · Lüftung
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 order-1 lg:order-2">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-brand-terracotta">
            {t("about.eyebrow")}
          </p>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-brand-ink leading-tight">
            {t("about.title")}
          </h2>

          <div className="mt-5 inline-flex items-baseline gap-2 bg-white border border-brand-sand rounded-full px-4 py-1.5">
            <span className="font-display text-lg font-semibold text-brand-ink">
              {t("about.name")}
            </span>
            <span className="text-sm text-brand-olive">— {t("about.origin")}</span>
          </div>

          <div className="mt-6 space-y-4 text-base sm:text-lg text-brand-ink/80 leading-relaxed">
            <p>{t("about.p1")}</p>
            <p>{t("about.p2")}</p>
            <p>{t("about.p3")}</p>
          </div>

          <div className="mt-8 flex flex-wrap gap-3">
            {["pill_1", "pill_2", "pill_3"].map((k) => (
              <span
                key={k}
                data-testid={`about-pill-${k}`}
                className="inline-flex items-center gap-2 rounded-full bg-white border border-brand-sand px-4 py-2 text-sm font-medium text-brand-ink"
              >
                <CheckCircle2 size={16} className="text-brand-terracotta" />
                {t(`about.${k}`)}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
